import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";
import { notify, urlApiTMAN } from "../../utils/utils";

const urlBaseDiagnostico = process.env.REACT_APP_TMAN_API + "/Diagnosis";
const urlBaseAlmacen = process.env.REACT_APP_TMAN_API + "/Store";
const urlBaseMovimiento = process.env.REACT_APP_TMAN_API + "/Store/Movement";
const urlBaseSetting = process.env.REACT_APP_TMAN_API + "/Setting";

export const useMovimientos = () => {
    const { stateUser, signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa;

    const movimientoDefault = {
        codEmpresa: 0,
        codDocumento: "",
        serieDocumento: "",
        correlativoDocumento: 0,
        codUsuarioCreacion: 0,
        codAlmacen: 0,
        codMotivo: 0,
        codDocumentoAdjunto: 0,
        serieDocumentoAdjunto: "",
        correlativoDocumentoAdjunto: "",
        comentario: "",
    };

    const movimientoDetalleDefault = {
        codEmpresa: codEmpresa,
        codAlmacenMovimient: 0,
        codRepuesto: 0,
        cantidadEntrada: 0,
        cantidadSalida: 0,
        cantidadAnterio: 0,
        cantidadActua: 0,
        codRepuestoU: 0,
    };

    const [movimiento, setMovimiento] = useState(movimientoDefault);
    const [movimientoDetalle, setMovimientoDetalle] = useState(
        movimientoDetalleDefault
    );
    const [tipoMovimientos, setTipoMovimientos] = useState([]);
    const [almacenes, setAlmacenes] = useState([]);
    const [almacenesPorUsuario, setAlmacenesPorUsuario] = useState([])
    const [estadosMovimiento, setEstadosMovimiento] = useState([]);

    const [ingresosInventario, setIngresosInventario] = useState([]);
    const [diagnosticosTaller, setDiagnosticosTaller] = useState([]);

    const [personasTaller, setPersonasTaller] = useState([]);

    const listarIngresoInventario = async (fechaInicio, fechaFin) => {
        const response = await AuthFetch({
            url:
                urlBaseAlmacen +
                "/enteredInventory?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                    CodUsuario: stateUser.codUsuario,
                    FechaInicio: fechaInicio,
                    FechaFin: fechaFin,
                }),
        });
        if (response.isValid) {
            setIngresosInventario(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    };

    const registrarIngresoInventario = async (
        arrRegistro,
        codDocumento,
        codAlmacen
    ) => {
        /*
        "arrRegistro" de la forma:
        [
            {
                "codRepuesto": 0,
                "registraSerieRespuesto": true,
                "cantidad": 0,
                "parametroSerie": [
                    {
                        "nomSerie": 0
                    }
                ]
            }
        ]
        */
        const response = await AuthFetch({
            url: urlBaseAlmacen + "/enteredInventory",
            method: "POST",
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codDocumento: codDocumento,
                codUsuarioCreacion: stateUser.codUsuario,
                codAlmacen: codAlmacen,
                almacenRespuestoDetalle: arrRegistro,
            }),
        });

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid
                ? response.content
                : response.exceptions[0].description,
        };
    };

    const listarDiagnosticoTaller = async (
        fechaInicio,
        fechaFin,
        codEstado
    ) => {
        const response = await AuthFetch({
            url:
                urlBaseDiagnostico +
                "?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                    codUsuario: stateUser.codUsuario
                }),
        });
        if (response.isValid) {
            setDiagnosticosTaller(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    };

    const registrarMovimiento = async () => {
        const response = await AuthFetch({
            url: urlBaseMovimiento,
            method: "POST",
            body: JSON.stringify(movimiento),
        });

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid
                ? response.content.desResultado
                : response.exceptions[0].description,
        };
    };

    const registrarDetalleMovimiento = async () => {
        const response = await AuthFetch({
            url: urlBaseMovimiento + "/detail",
            method: "POST",
            body: JSON.stringify(movimientoDetalle),
        });

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid
                ? response.content.desResultado
                : response.exceptions[0].description,
        };
    };

    const listarTipoDeMovimientos = async () => {
        const response = await AuthFetch({
            url:
                urlBaseAlmacen +
                "/admissionReason?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                }),
        });
        if (response.isValid) {
            setTipoMovimientos(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    };

    const listarAlmacenes = async () => {
        const response = await AuthFetch({
            url:
                urlBaseAlmacen +
                "/combos?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                    CodUsuarioAccion: 0,
                }),
        });
        if (response.isValid) {
            setAlmacenes(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    };

    const listarAlmacenesPorUsuario = async () => {
        const response = await AuthFetch({
            url:
                urlBaseAlmacen +
                "/combos?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                    CodUsuarioAccion: stateUser.codUsuario,
                }),
        });
        if (response.isValid) {
            setAlmacenesPorUsuario(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    }

    const listarEstadosMovimiento = async () => {
        const response = await AuthFetch({
            url:
                urlBaseSetting +
                "/store?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                }),
        });
        if (response.isValid) {
            setEstadosMovimiento(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    };

    const listarComboPersonasTaller = async () => {
        const response = await AuthFetch({
            url:
                urlBaseSetting +
                "/taller?" +
                new URLSearchParams({
                    codEmpresa: codEmpresa,
                }),
        });
        if (response.isValid) {
            setPersonasTaller(response.content);
        } else {
            notify(response.exceptions[0].description, "error");
        }
    };

    const registrarSalidaPorOT = async ({
        codPersonaEntrega,
        codOrdenTrabajo,
        comentarioSalidaPedido,
        pedidoDetalle,
    }) => {
        /*
        pedidoDetalle es de la forma: 
            [
                {
                    codRepuesto: 0,
                    cantidad: 0,
                    series: [
                        {
                            codSerieRepuesto: 0
                        }
                    ]
                }
            ]
        */
        const response = await AuthFetch({
            url: urlBaseAlmacen + "/Diagnosis",
            method: "POST",
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codPersonaEntrega: codPersonaEntrega,
                codUsuarioAccion: stateUser.codUsuario,
                codOrdenTrabajo: codOrdenTrabajo,
                comentarioSalidaPedido: comentarioSalidaPedido,
                pedidoDetalle: pedidoDetalle,
            }),
        });
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid
                ? response.content
                : response.exceptions[0].description,
        };
    };


    const anularSalidaPorTraslado = async ({
        codTransferencia = '',
        comentarioEliminacion = ''
    }) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer',
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codTransferencia: codTransferencia,
                codUsuarioAccion: stateUser.codUsuario,
                comentarioEliminacion: comentarioEliminacion
            })
        })

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    return {
        listarIngresoInventario,
        ingresosInventario,
        listarDiagnosticoTaller,
        diagnosticosTaller,
        movimientoDefault,
        movimiento,
        setMovimiento,
        movimientoDetalleDefault,
        movimientoDetalle,
        setMovimientoDetalle,
        registrarMovimiento,
        registrarDetalleMovimiento,
        listarTipoDeMovimientos,
        tipoMovimientos,
        listarAlmacenes,
        almacenes,
        listarEstadosMovimiento,
        estadosMovimiento,
        registrarIngresoInventario,
        personasTaller,
        listarComboPersonasTaller,
        registrarSalidaPorOT,
        anularSalidaPorTraslado,
        listarAlmacenesPorUsuario,
        almacenesPorUsuario
    };
};
